import type { RestaurantResponse } from '@/features/restaurants/types';
import { useRestaurantLanguage, toI18nLanguage } from '@/shared/hooks/useRestaurantLanguage';

export { toI18nLanguage };

/** Storefront wrapper — accepts the full RestaurantResponse so existing callers don't change. */
export function usePublicRestaurantLanguage(restaurant: RestaurantResponse | undefined) {
  useRestaurantLanguage(restaurant?.defaultLanguage);
}
